/* eslint-disable max-len */

import React from 'react';
import { Svg, Path, G } from '@react-pdf/renderer';

export const OpeningDinnerIcon: React.FC = () => {
  return (
    <Svg width={42} height={42}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
          fill="#CCCBCB"
          fillRule="nonzero"
        />
        <Path d="M5 7h29v29H5z" />
        <Path
          d="M24.889 14.8V22c0 1.32 1.1 2.4 2.444 2.4h1.223v8.4c0 .66.55 1.2 1.222 1.2.672 0 1.222-.54 1.222-1.2V11.356c0-.78-.746-1.356-1.516-1.176-2.64.636-4.595 2.832-4.595 4.62Zm-6.111 3.6h-2.445v-7.2c0-.66-.55-1.2-1.222-1.2-.672 0-1.222.54-1.222 1.2v7.2h-2.445v-7.2c0-.66-.55-1.2-1.222-1.2C9.55 10 9 10.54 9 11.2v7.2c0 2.652 2.188 4.8 4.889 4.8v9.6c0 .66.55 1.2 1.222 1.2.672 0 1.222-.54 1.222-1.2v-9.6c2.701 0 4.89-2.148 4.89-4.8v-7.2c0-.66-.55-1.2-1.223-1.2-.672 0-1.222.54-1.222 1.2v7.2Z"
          fill="#575B65"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
};
